import React, { Component } from 'react'
import intl from 'react-intl-universal'
import { inject, PropTypes } from 'mobx-react'
import Select from 'react-select'
import { register } from '../api'
import Input from './Input'
import 'formdata-polyfill'

// TODO: @ynt, we need fix styles for `react-select` — @mrauhu
import 'react-select/dist/react-select.css'
import object_value from '../api/object_value'
import { NotificationManager } from 'react-notifications'
import return_html from '../api/return_html'

/**
 * Create range inclusive
 * @param {number} from
 * @param {number} to
 * @return {Array}
 */
function range (from, to) {
  const arr = []
  for (; from <= to; from++) {
    arr.push({
      value: from,
      label: from
    })
  }
  return arr
}

@inject('user', 'modals')
class RegisterForm extends Component {
  constructor (props, context) {
    super(props, context)

    const currentYear = (new Date()).getUTCFullYear()

    this.state = {
      form_class: 'b-form',
      status: '',
      message: '',
      date_is_valid: true,
      mismatched_password: false,
      years: range(1900, currentYear).reverse(),
      months: range(1, 12),
      daysInMonthByYear: 31,
      // After using `<Select />` we got content `{ value, label }`
      // but if set `{}` we got empty placeholder instead `Select...`
      day: null,
      month: null,
      year: null
    }
  }

  // Enable browser form validation on any input change
  makeValidationVisible = () => {
    // Make validation errors visible
    if (this.state.form_class === 'b-form') {
      this.setState({form_class: this.state.form_class + ' b-form_allow-browser-validation'})
    }
  }

  // Elegant way of binding handler to (this) without `constructor(){ super() }`
  handleInput = async () => {
    // console.log('input')
  }

  // Elegant way of binding handler to (this) without `constructor(){ super() }`
  handleSubmit = async (event) => {
    event.preventDefault()

    // Process form data
    const data = new FormData(event.target)

    // Display the key/value pairs
    console.log('handleSubmit() - data')

    // Reset date validation
    this.setState({'date_is_valid': true})

    // Check if date filled
    if (!data.get('year') ||
      !data.get('month') ||
      !data.get('day')
    ) {
      console.log("data.get('year'), data.get('month'), data.get('day'):", data.get('year'), data.get('month'), data.get('day'))
      this.setState({'date_is_valid': false})

      return false
    }

    // Create birthday date from: day, month, year
    const birthday = new Date(
      data.get('year'),
      data.get('month'),
      data.get('day')
    )

    // Check age
    // https://stackoverflow.com/a/7091965/8551889
    function getAge (dateString) {
      let today = new Date()
      let birthDate = new Date(dateString)
      let age = today.getFullYear() - birthDate.getFullYear()
      let m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      console.log('age:', age)
      return age
    }

    // Check if date filled
    if (getAge(birthday) < 18) {
      this.setState({'date_is_valid': false})

      return false
    }

    // ISO 8601 date without milliseconds part
    const birthdate = birthday.toISOString().split('.')[0] + 'Z'
    // Fix: remove unused values or API will halt
    data.delete('year')
    data.delete('month')
    data.delete('day')
    console.log('birthday', birthday, birthdate)
    data.set('birthdate', birthdate)

    // Reset mismatched password status
    this.setState({'mismatched_password': false})

    // Compare passwords
    if (data.get('password') !== data.get('password_repeat')) {
      this.setState({'mismatched_password': true})

      return false
    }

    // Delete password repeat
    data.delete('password_repeat')

    // Send a request
    let response = await register(data)
    console.log('handleSubmit() - response', response)

    // Error
    if (!response.ok) {
      let message = object_value(response, 'data.message', 'Error')
      let errors = object_value(response, 'data.errors', {})

      NotificationManager.error(message, 'Error!', 2500)

      if (errors !== null && typeof errors === 'object') {
        for (let [key, value] of Object.entries(errors)) {
          if (value.length > 0) {
            let fetch_text = ''

            value.forEach(t => {
              fetch_text = fetch_text + t + '<br>'
            })

            message = message + `<br><strong>${key}</strong>:<br>${fetch_text}`
          }
        }
      }

      if (this.refs.RegisterForm) { // Prevent a warning - https://stackoverflow.com/a/40969739
        this.setState({
          status: 'error',
          message
        })
      }

      return false
    }

    let token = object_value(response, 'data.token')

    // No token
    if (!token) {
      NotificationManager.error('Token has not been received', 'Server error!', 2500)

      if (this.refs.RegisterForm) { // Prevent a warning - https://stackoverflow.com/a/40969739
        this.setState({
          status: 'error',
          message: 'Token has not been received'
        })
      }

      return false
    }

    this.props.user.setToken(token)

    // Notify
    NotificationManager.success('You have been registered', 'Success!', 5000)

    // Close the modal
    this.props.modals.setModal('')
    document.body.classList.toggle('js-modal-opened')
    document.body.scrollIntoView()

    // Success
    if (this.refs.RegisterForm) {
      this.setState({
        status: 'success',
        // message
      })
    }
  }

  // Handle submits for birthday
  handleChangeYear = (year) => {
    this.setState({year})
    this.updateDays(year, this.state.month)
  }
  handleChangeMonth = (month) => {
    this.setState({month})
    this.updateDays(this.state.year, month)
  }
  handleChangeDay = (day) => {
    this.setState({day})
  }

  /**
   * Update days in month by year
   * for fixing leap-year number of days in February
   * @param {Object|*} year
   * @param {number} year.value
   * @param {Object|*} month
   * @param {number} month.value
   */
  updateDays (year, month) {
    const daysInMonthByYear = year && month &&
      typeof year.value !== 'undefined' && // Welcome to JavaScript
      typeof month.value !== 'undefined'
      ? new Date(year.value, month.value, 0).getDate()
      : 31
    console.log('daysInMonthByYear', daysInMonthByYear, year, month)
    this.setState({daysInMonthByYear})
  }

  handleOnclickModal = (event) => {
    event.preventDefault()
    this.props.modals.setModal('LoginModal')
  }

  render () {
    // Fix: empty values of `react-select`
    // or we got empty selects if we using `options={this.state...}`
    const years = this.state.years
    const months = this.state.months
    const days = range(1, this.state.daysInMonthByYear)

    return (
      <form ref="RegisterForm"
            className={this.state.form_class}
            onInput={this.handleInput}
            onSubmit={this.handleSubmit}>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   id='email'
                   name='email'
                   type='email'
                   required />
            <label className='b-form-item-label' htmlFor='email'>
              {intl.get('E-Mail')}
            </label>
          </div>
        </div>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   id='prename'
                   name='prename'
                   required />
            <label className='b-form-item-label'
                   htmlFor='prename'>
              {intl.get('First name')}
            </label>
            <div className='b-form-item-mark'>{intl.get('Seen by public')}</div>
          </div>
        </div>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   id='surname'
                   name='surname'
                   required />
            <label className='b-form-item-label'
                   htmlFor='surname'>
              {intl.get('Last name')}
            </label>
          </div>
        </div>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <label className='b-form-item-radio'>
              <input name='gender'
                     type='radio'
                     defaultChecked
                     value='f' />
              <span>{intl.get('Female')}</span>
            </label>
          </div>

          <div className='b-form-item b-form-item_x'>
            <label className='b-form-item-radio'>
              <input name='gender'
                     type='radio'
                     value='m' />
              <span>{intl.get('Male')}</span>
            </label>
          </div>

          <div className='b-form-item' />
        </div>

        <div className='b-form-row'>
          <div className={this.state.date_is_valid ? 'b-form-item b-form-item_x' : 'b-form-item b-form-item_x is_invalid'}>
            <div className='b-form-item-wrapSelect'>
              <Select name='year' id='year'
                      options={years}
                      value={this.state.year}
                      onChange={this.handleChangeYear}
                      searchable={false}
                      required />
            </div>
            <label className='b-form-item-label' htmlFor='year'>
              {intl.get('Year')}
            </label>
          </div>

          <div className='b-form-item b-form-item_x'>
            <div className='b-form-item-wrapSelect'>
              <Select name='month' id='month'
                      options={months}
                      value={this.state.month}
                      onChange={this.handleChangeMonth}
                      searchable={false}
                      required />
            </div>
            <label className='b-form-item-label'
                   htmlFor='month'>
              {intl.get('Month')}
            </label>
          </div>

          <div className='b-form-item b-form-item_x'>
            <div className='b-form-item-wrapSelect'>
              <Select name='day' id='day'
                      options={days}
                      value={this.state.day}
                      onChange={this.handleChangeDay}
                      searchable={false}
                      required />
            </div>
            <label className='b-form-item-label'
                   htmlFor='day'>
              {intl.get('Day')}
            </label>
          </div>
        </div>
        {!this.state.date_is_valid && <div className='b-form-message'>{intl.get('You must be at least 18 years old')}</div>}

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   id='job'
                   name='job' />
            <label className='b-form-item-label'
                   htmlFor='job'>
              {intl.get('Job')}
            </label>
          </div>
        </div>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   id='city'
                   name='city'
                   required />
            <label className='b-form-item-label'
                   htmlFor='city'>
              {intl.get('City')}
            </label>
          </div>
        </div>

        <div className='b-form-row'>
          <div className='b-form-item b-form-item_x'>
            <Input className='b-form-item-input-text'
                   minLength={8}
                   type='password'
                   id='password'
                   name='password'
                   required />
            <label className='b-form-item-label'
                   htmlFor='password'>
              {intl.get('Password')}
            </label>
          </div>
        </div>

        <div className='b-form-row'>
          <div className={!this.state.mismatched_password ? 'b-form-item b-form-item_x' : 'b-form-item b-form-item_x is_invalid'}>
            <Input className='b-form-item-input-text'
                   type='password'
                   id='password_repeat'
                   name='password_repeat'
                   required />
            <label className='b-form-item-label'
                   htmlFor='password_repeat'>
              {intl.get('Repeat password')}
            </label>
          </div>
        </div>

        {this.state.status === 'loading' &&
        <div className='b-form-success'>Loading...</div>}

        {this.state.status === 'error' &&
        <div className='b-form-success'
             dangerouslySetInnerHTML={return_html(this.state.message)} />}

        {this.state.status === 'success' &&
        <div className='b-form-success'>{this.state.message}</div>}

        {this.state.status !== 'success' &&
        <div className='b-form-row'>
          <button type='submit'
                  className='b-button b-button_primary b-button_x'
                  onClick={this.makeValidationVisible}>
            {intl.get('Register')}
          </button>
        </div>}

        <p className='text-center'>You already have an account?&nbsp;
          <button className='b-link'
                  type='button'
                  onClick={this.handleOnclickModal}>
            {intl.get('Login now')}
          </button>
        </p>
      </form>
    )
  }
}

RegisterForm.propTypes = {
  user: PropTypes.observableObject,
  modals: PropTypes.observableObject
}

export default RegisterForm



// WEBPACK FOOTER //
// ./src/components/RegisterForm.js